import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34955bc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "courier-id" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center flex-col bg-white border px-6 py-4"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-sm mt-2" }, "Загрузка данных о курьере...", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 text-sm" }, " При получении данных о курьере произошла ошибка ", -1))
const _hoisted_11 = { class: "grid grid-cols-3 gap-3 bg-white border px-6 py-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "ИИН", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Код 1С", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Телефон", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Тип оплаты", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Сумма оплаты", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Сектор диспетчера", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Дата создания", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Название компании", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Номер заявки Jira", -1))
const _hoisted_21 = {
  key: 0,
  class: "mt-6 grid grid-cols-3 gap-3 bg-white border px-6 py-4"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Гос. номер", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Модель", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Тип машины", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Компания", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Код 1С", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Грузоподъемность", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Кубатура", -1))
const _hoisted_29 = {
  key: 2,
  class: "bg-white border px-6 py-4 mt-6"
}
const _hoisted_30 = { class: "text-lg font-semibold" }
const _hoisted_31 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_34 = {
  key: 1,
  class: "mt-3 text-gray-400 text-sm"
}
const _hoisted_35 = {
  key: 3,
  class: "bg-white border px-6 py-4 mt-6"
}
const _hoisted_36 = { class: "text-lg font-semibold" }
const _hoisted_37 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 1,
  class: "mt-3 text-gray-400 text-sm"
}
const _hoisted_40 = {
  key: 4,
  class: "bg-white border px-6 py-4 mt-6"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Загрузка удостоверения", -1))
const _hoisted_42 = { class: "flex items-center justify-end mt-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload mr-2" }, null, -1))
const _hoisted_44 = {
  key: 5,
  class: "bg-white border px-6 py-4 mt-6"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Загрузка водительских прав", -1))
const _hoisted_46 = { class: "flex items-center justify-end mt-3" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_history = _resolveComponent("history")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_page_title, {
          title: 
                        _ctx.state.courier
                            ? `${_ctx.state.courier.fullName} (ID: ${_ctx.courier_id})`
                            : `(ID: ${_ctx.courier_id})`
                    
        }, null, 8, ["title"]),
        (Boolean(_ctx.state.courier))
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: _normalizeClass(["small ml-3", {
                        yellow: _ctx.isCourierOnCheck,
                        green: _ctx.isCourierActive,
                        red: _ctx.isCourierArchive || _ctx.isCourierReject,
                    }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.courier.status.title), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isCanReject)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              loading: _ctx.reject_state.is_loading,
              class: "red small text mr-3",
              onClick: _ctx.rejectCourier
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" Отказ ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isRenderOnCheckStatusButton)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              loading: _ctx.state.is_status_change_loading,
              class: "yellow text small mr-3",
              onClick: _ctx.setOnCheckStatus
            }, {
              default: _withCtx(() => [
                _createTextVNode(" На проверке(СБ) ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isRenderActiveStatusButton)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 2,
              loading: _ctx.state.is_status_change_loading,
              class: "green text small mr-3",
              onClick: _ctx.setActiveStatus
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Активировать ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isRenderArchiveStatusButton)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 3,
              loading: _ctx.state.is_status_change_loading,
              class: "red text small mr-3",
              onClick: _ctx.setArchiveStatus
            }, {
              default: _withCtx(() => [
                _createTextVNode(" В архив ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_the_button, {
          class: "second small text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/couriers')))
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" Назад ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.state.is_loading || _ctx.state.is_failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_9
                ], 64))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_10,
                    _createVNode(_component_the_button, {
                      class: "primary small text mt-3",
                      onClick: _ctx.loadCourier
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перезагрузить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _hoisted_12,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.courier.iin || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.courier.code1C), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_14,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.courier.phoneNumber), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("p", null, [
                  (_ctx.state.courier.paymentRateType)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.state.courier.paymentRateType.title), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_16,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.courier.paymentAmount), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_17,
                _createElementVNode("p", null, [
                  (_ctx.state.courier.dispatcherSector)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.state.courier.dispatcherSector.name), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("-")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_18,
                _createElementVNode("p", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.courier.createdAt)), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _createElementVNode("p", null, [
                  (_ctx.state.courier.company)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.state.courier.company.name), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("-")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.courier.jiraTicket), 1)
              ])
            ]),
            (Boolean(_ctx.state.courier) && Boolean(_ctx.state.courier.car))
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", null, [
                    _hoisted_22,
                    _createElementVNode("p", null, _toDisplayString(_ctx.state.courier.car.number), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_23,
                    _createElementVNode("p", null, _toDisplayString(_ctx.state.courier.car.model), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_24,
                    _createElementVNode("p", null, [
                      (_ctx.state.courier.car)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.state.courier.car.carType.title), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_25,
                    _createElementVNode("p", null, _toDisplayString(_ctx.companyName), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_26,
                    _createElementVNode("p", null, _toDisplayString(_ctx.state.courier.car.code1C), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_27,
                    _createElementVNode("p", null, [
                      (_ctx.state.courier.car && _ctx.state.courier.car.ftlCarType)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.state.courier.car.ftlCarType.title), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" - ")
                          ], 64))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_28,
                    _createElementVNode("p", null, [
                      (_ctx.state.courier.car)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.state.courier.car.cubature), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" - ")
                          ], 64))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      (Boolean(_ctx.state.courier))
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("p", _hoisted_30, " Фото удостоверения (" + _toDisplayString(_ctx.state.courier.identificationCards.length) + ") ", 1),
            (Boolean(_ctx.state.courier.identificationCards.length))
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.courier.identificationCards, (photo) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: photo.url,
                      class: "mt-2 flex justify-between items-center"
                    }, [
                      _createElementVNode("img", {
                        class: "object-cover",
                        style: {"max-width":"800px","max-height":"400px"},
                        src: photo.url
                      }, null, 8, _hoisted_32),
                      _createVNode(_component_the_button, {
                        class: "primary small text",
                        loading: _ctx.upload_state.is_certificate_loading,
                        onClick: ($event: any) => (_ctx.saveFileByURL(photo.url))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_33,
                          _createTextVNode(" Скачать ")
                        ]),
                        _: 2
                      }, 1032, ["loading", "onClick"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_34, "Фото удостоверения не загружены"))
          ]))
        : _createCommentVNode("", true),
      (Boolean(_ctx.state.courier))
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("p", _hoisted_36, " Фото водительских прав (" + _toDisplayString(_ctx.state.courier.driverLicenses.length) + ") ", 1),
            (Boolean(_ctx.state.courier.driverLicenses.length))
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.courier.driverLicenses, (photo) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: photo.url,
                      class: "mt-2 object-cover",
                      style: {"max-width":"800px","max-height":"400px"},
                      src: photo.url
                    }, null, 8, _hoisted_38))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, " Фото водительских прав не загружены "))
          ]))
        : _createCommentVNode("", true),
      (Boolean(_ctx.state.courier) && _ctx.isCanUploadDocuments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _hoisted_41,
            _createVNode(_component_file_reader, {
              class: "mt-3",
              placeholder: "Выберите изображение",
              accept: "image/*",
              multiple: "",
              value: _ctx.upload_state.certificate,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.upload_state.certificate) = $event)),
              disabled: _ctx.upload_state.is_certificate_loading,
              "is-invalid": _ctx.upload_state$.certificate.$error,
              "validation-errors": _ctx.upload_state$.certificate.$errors
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_the_button, {
                class: "primary small text",
                loading: _ctx.upload_state.is_certificate_loading,
                onClick: _ctx.uploadCertificate
              }, {
                default: _withCtx(() => [
                  _hoisted_43,
                  _createTextVNode(" Загрузить ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (Boolean(_ctx.state.courier) && _ctx.isCanUploadDocuments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _hoisted_45,
            _createVNode(_component_file_reader, {
              class: "mt-3",
              placeholder: "Выберите изображение",
              accept: "image/*",
              multiple: "",
              value: _ctx.upload_state.drive_license,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.upload_state.drive_license) = $event)),
              disabled: _ctx.upload_state.is_drive_license_loading,
              "is-invalid": _ctx.upload_state$.drive_license.$error,
              "validation-errors": _ctx.upload_state$.drive_license.$errors
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_the_button, {
                class: "primary small text",
                loading: _ctx.upload_state.is_drive_license_loading,
                onClick: _ctx.uploadDriverLicense
              }, {
                default: _withCtx(() => [
                  _hoisted_47,
                  _createTextVNode(" Загрузить ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isHistory)
        ? (_openBlock(), _createBlock(_component_history, {
            key: 6,
            class: "mt-6",
            identifier: _ctx.state.courier.iin,
            type: 2
          }, null, 8, ["identifier"]))
        : _createCommentVNode("", true)
    ])
  ]))
}